import { useEffect, useState } from "react";
import DebateGeniusIndex from "./DebateGenius/Index";
import { TYPO } from "styles/Typo";
import DetailAINewsRader from "./NewLader/NewsRader";
import useIsDetailLoading from "states/detailLoading";
import { useRouter } from "next/router";
import { trackPageAction } from "lib/analytics/core/actions";

function DetailAIFeedIndex({ detailData }: { detailData: any }) {
  const router = useRouter();
  const isLoading = useIsDetailLoading();
  // const [tab, setTab] = useState<"debateGenius" | "news">("news");
  const tab = router.query?.sub || "news";

  if (isLoading) return <div></div>;
  return (
    <div>
      <div className="pt-4 px-6 flex ">
        <button
          className={`flex items-center justify-center px-[14px] py-2 rounded-[12px] cursor-pointer ${
            tab === "news"
              ? `bg-gray10 ${TYPO.TYPO7_SB} text-gray80`
              : `bg-transparent ${TYPO.TYPO7_MD} text-gray50`
          }`}
          onClick={() => {
            trackPageAction("filter_stock_feed");
            router.replace(
              `/detail/${detailData?.ITEM_CD_DL}?tab=aireport&sub=news`,
              undefined,
              {
                shallow: true,
              }
            );
          }}
        >
          주가 뉴스
        </button>
        <button
          className={`flex items-center justify-center px-[14px] py-2 rounded-[12px] cursor-pointer ${
            tab === "report"
              ? `bg-gray10 ${TYPO.TYPO7_SB} text-gray80`
              : `bg-transparent ${TYPO.TYPO7_MD} text-gray50`
          }`}
          onClick={() => {
            trackPageAction("filter_stock_feed");
            router.replace(
              `/detail/${detailData?.ITEM_CD_DL}?tab=aireport&sub=report`,
              undefined,
              {
                shallow: true,
              }
            );
          }}
        >
          리포트
        </button>
      </div>
      {tab === "report" && <DebateGeniusIndex detailData={detailData} />}
      {tab === "news" && <DetailAINewsRader detailData={detailData} />}
    </div>
  );
}

export default DetailAIFeedIndex;
